module.exports = __webpack_public_path__ + "media/diverticular bleeding.fc9c311f.wav";